/*
 * Copyright (c) 2000-2023 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */


import {ActorProvider} from 'spine-web/index';

/**
 * A provider of the actor that associates requests to the License Server backend
 * with an application user.
 */
const actor = new ActorProvider();

export default actor;
